module.exports = __webpack_public_path__ + "assets/img/the-white-house.8c3dd76e.svg";